export default __webpack_public_path__ + "static/media/addProfile.4e669479.svg";